import React from "react";

const sizeClasses = {
  txtPoppinsMedium14Gray90003: "font-medium font-poppins",
  txtPoppinsSemiBold24Bluegray900: "font-poppins font-semibold",
  txtPoppinsSemiBold16: "font-poppins font-semibold",
  txtLatoRegular14: "font-lato font-normal",
  txtPoppinsMedium14WhiteA70087: "font-medium font-poppins",
  txtPoppinsMedium18Indigo900: "font-medium font-poppins",
  txtPoppinsMedium22Bluegray900: "font-medium font-poppins",
  txtPoppinsSemiBold48Indigo900: "font-poppins font-semibold",
  txtPoppinsMedium32Cyan400: "font-medium font-poppins",
  txtPoppinsRegular18: "font-normal font-poppins",
  txtPoppinsRegular14: "font-normal font-poppins",
  txtPoppinsRegular16: "font-normal font-poppins",
  txtPoppinsSemiBold24: "font-poppins font-semibold",
  txtPoppinsMedium24Black90002: "font-medium font-poppins",
  txtPoppinsRegular24: "font-normal font-poppins",
  txtPoppinsSemiBold20: "font-poppins font-semibold",
  txtPoppinsRegular20: "font-normal font-poppins",
  txtPoppinsMedium18Bluegray900: "font-medium font-poppins",
  txtPoppinsSemiBold32Bluegray400: "font-poppins font-semibold",
  txtPoppinsMedium20WhiteA70087: "font-medium font-poppins",
  txtPoppinsRegular16Bluegray400: "font-normal font-poppins",
  txtDMSansBold22: "font-bold font-dmsans",
  txtPoppinsMedium50: "font-medium font-poppins",
  txtPoppinsMedium12Bluegray400: "font-medium font-poppins",
  txtPoppinsMedium12WhiteA700: "font-medium font-poppins",
  txtPoppinsMedium22Bluegray400: "font-medium font-poppins",
  txtPoppinsRegular12: "font-normal font-poppins",
  txtPoppinsMedium20Bluegray90003: "font-medium font-poppins",
  txtPoppinsMedium16Bluegray900: "font-medium font-poppins",
  txtPoppinsSemiBold32: "font-poppins font-semibold",
  txtPoppinsMedium22Black900: "font-medium font-poppins",
  txtPoppinsRegular16Bluegray40087: "font-normal font-poppins",
  txtPoppinsMedium20Bluegray90004: "font-medium font-poppins",
  txtPoppinsMedium24Bluegray90005: "font-medium font-poppins",
  txtPoppinsMedium18Black900: "font-medium font-poppins",
  txtWorkSansBold18Gray90006: "font-bold font-worksans",
  txtPoppinsRegular12Cyan400: "font-normal font-poppins",
  txtPoppinsMedium14Black900: "font-medium font-poppins",
  txtPoppinsMedium20Bluegray50001: "font-medium font-poppins",
  txtPoppinsMedium20Cyan400: "font-medium font-poppins",
  txtPoppinsBold64: "font-bold font-poppins",
  txtPoppinsMedium20Bluegray400: "font-medium font-poppins",
  txtPoppinsRegular16WhiteA70001: "font-normal font-poppins",
  txtInterRegular981: "font-inter font-normal",
  txtPoppinsRegular16Bluegray900a201: "font-normal font-poppins",
  txtPoppinsSemiBold48: "font-poppins font-semibold",
  txtPoppinsSemiBold32Bluegray900: "font-poppins font-semibold",
  txtPoppinsMedium16Green800: "font-medium font-poppins",
  txtPoppinsMedium24Bluegray900: "font-medium font-poppins",
  txtDMSansMedium14: "font-dmsans font-medium",
  txtRobotoRegular16: "font-normal font-roboto",
  txtPoppinsMedium40: "font-medium font-poppins",
  txtPoppinsMedium16Bluegray90005: "font-medium font-poppins",
  txtPoppinsBold18Indigo900: "font-bold font-poppins",
  txtPoppinsRegular16Gray80004: "font-normal font-poppins",
  txtPoppinsMedium48: "font-medium font-poppins",
  txtPoppinsRegular18WhiteA700: "font-normal font-poppins",
  txtPoppinsMedium14Gray90087: "font-medium font-poppins",
  txtPoppinsSemiBold20Cyan400: "font-poppins font-semibold",
  txtPoppinsMedium20Black90003: "font-medium font-poppins",
  txtPoppinsSemiBold32Black90004: "font-poppins font-semibold",
  txtPoppinsMedium32Black900: "font-medium font-poppins",
  txtPoppinsSemiBold32Black900: "font-poppins font-semibold",
  txtPoppinsRegular16WhiteA700: "font-normal font-poppins",
  txtPoppinsMedium36: "font-medium font-poppins",
  txtPoppinsMedium32: "font-medium font-poppins",
  txtWorkSansBold18Indigo900: "font-bold font-worksans",
  txtPoppinsRegular18Indigo900: "font-normal font-poppins",
  txtPoppinsRegular16Black900: "font-normal font-poppins",
  txtWorkSansSemiBold18: "font-semibold font-worksans",
  txtPoppinsMedium16Cyan400: "font-medium font-poppins",
  txtPoppinsMedium14Cyan400: "font-medium font-poppins",
  txtPoppinsMedium18Gray90005: "font-medium font-poppins",
  txtWorkSansRegular18: "font-normal font-worksans",
  txtPoppinsMedium12Cyan400: "font-medium font-poppins",
  txtWorkSansRegular16: "font-normal font-worksans",
  txtWorkSansRegular14: "font-normal font-worksans",
  txtPoppinsMedium24: "font-medium font-poppins",
  txtPoppinsRegular16Blue10001: "font-normal font-poppins",
  txtPoppinsMedium22: "font-medium font-poppins",
  txtPoppinsMedium14Bluegray400: "font-medium font-poppins",
  txtPoppinsMedium20: "font-medium font-poppins",
  txtPoppinsMedium24Bluegray400: "font-medium font-poppins",
  txtPoppinsBold50: "font-bold font-poppins",
  txtPoppinsMedium24WhiteA700: "font-medium font-poppins",
  txtPoppinsMedium16Bluegray50001: "font-medium font-poppins",
  txtPoppinsRegular12Gray60001: "font-normal font-poppins",
  txtPoppinsMedium18Bluegray10002: "font-medium font-poppins",
  txtPoppinsBold18Cyan400: "font-bold font-poppins",
  txtPoppinsBold18: "font-bold font-poppins",
  txtPoppinsMedium20Black900: "font-medium font-poppins",
  txtPoppinsMedium18Bluegray400: "font-medium font-poppins",
  txtDMSansMedium14WhiteA700: "font-dmsans font-medium",
  txtPoppinsMedium16Indigo900: "font-medium font-poppins",
  txtPoppinsRegular16Indigo900: "font-normal font-poppins",
  txtPoppinsMedium14: "font-medium font-poppins",
  txtPoppinsMedium16Black900: "font-medium font-poppins",
  txtPoppinsMedium12: "font-medium font-poppins",
  txtPoppinsMedium10: "font-medium font-poppins",
  txtManropeSemiBold14: "font-manrope font-semibold",
  txtPoppinsMedium48Black900: "font-medium font-poppins",
  txtPoppinsMedium18: "font-medium font-poppins",
  txtPoppinsMedium16: "font-medium font-poppins",
  txtWorkSansBold18: "font-bold font-worksans",
  txtPoppinsMedium16Bluegray80001: "font-medium font-poppins",
  txtPoppinsMedium12Black900: "font-medium font-poppins",
  txtWorkSansMedium26: "font-medium font-worksans",
  txtPoppinsMedium16PinkA200: "font-medium font-poppins",
  txtPoppinsMedium16WhiteA700: "font-medium font-poppins",
  txtPoppinsBold18PinkA200: "font-bold font-poppins",
  txtPoppinsRegular9: "font-normal font-poppins",
  txtPoppinsMedium20Gray80001: "font-medium font-poppins",
  txtPoppinsMedium14Bluegray10002: "font-medium font-poppins",
  txtDMSansRegular16: "font-dmsans font-normal",
  txtPoppinsSemiBold48WhiteA700: "font-poppins font-semibold",
  txtDMSansRegular18: "font-dmsans font-normal",
};

const Text = ({ children, className = "", size, as, ...restProps }) => {
  const Component = as || "p";

  return (
    <Component
      className={`text-left ${className} ${size && sizeClasses[size]}`}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export { Text };
